import React from "react";
import { Loader2 } from "lucide-react";

interface WidgetState {
    data: any;
}

interface WidgetChild {
    data?: any;
    load?: any;
    render: (...args: any[]) => any;
}

export class Widget extends React.Component<{ children?: WidgetChild }, WidgetState> {
    constructor(props: any) {
        super(props);
        this.state = { data: null };
    }
    loading: boolean;

    componentDidMount() {
        const setState = (children, data) => {
            this.loading = false;
            this.setState({ data });
        };
        const { children } = this.props;
        if (children.load && !children.data && this.loading !== true) {
            this.loading = true;
            let loadResult;
            if (children.load instanceof Promise) {
                loadResult = children.load;
            } else {
                loadResult = children.load();
            }
            if (loadResult instanceof Promise) {
                loadResult
                    .then((resp) => {
                        setState(children, Array.isArray(resp) ? resp.map((d) => d.data) : resp.data);
                        return true;
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                setState(children, loadResult);
            }
        }
    }
    render() {
        const { children } = this.props;
        let data = children.data;
        if (!data && this.state.data) {
            data = this.state.data;
        }
        return <div className="widget">{data ? children.render({ data }) : <Loader2 className="h-8 w-8 animate-spin" />}</div>;
    }
}
